import { axios } from 'libs';

export const login = auth => {
  return axios.post('/authenticate', auth);
};
